import "./style.css";

const MaterialButton = (props) => {
    const {
        title,
        icon,
        type,
        onClick,
    } = props

    return <div 
        className={`material-button ${type}`} 
        style={{backgroundImage: "url("+ process.env.REACT_APP_API_URL + icon+")"}}
        onClick={onClick}
    >
        <span>{title}</span>
    </div>
}

export default MaterialButton;